/*
 *
 *  AOS
 */

// deps
import Vue from 'vue'
import VueAnime from 'vue-animejs'

// use
Vue.use(VueAnime)
